import "./WireMeshSpecifications.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import SpecificationsHero from "./sections/SpecificationsHero";
import Specifications from "./sections/Specifications";
import QuoteBanner from "./sections/QuoteBanner";
import Footer from "@/reusable_sections/Footer";
export default function WireMeshSpecificationsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="WireMeshSpecifications" />
      <SpecificationsHero />
      <Specifications />
      <QuoteBanner />
      <Footer />
    </div>;
}